import React from "react";
import { Combobox } from "react-widgets";
import "react-widgets/styles.css";
import plusIcon from "../../../assets/icons/plus-icon.png";

import saveIcon from "../../../";
import AlertMessage from "../../../components/AlertMessage";
import BarberUnavailabilityModal from "./barberUnAvailabilityModal";
import DeleteConfirmationModal from "../../../components/DeleteConfirmationModal";
import useBarberUnavailability from "../../../hooks/barber/useBarberUnavailability";
import Breadcrumb from "../../../components/Breadcrumb";
import Table from "../../../components/Table/Table.jsx";

const BarberUnavailability = () => {
  const {
    barberList,
    selectedBarber,
    unavailabilities,
    selectedToDate,
    columns,
    setSelectedToDate,
    selectedFromDate,
    setSelectedFromDate,
    message,
    showMessage,
    setShowMessage,
    setSelectedBarber,
    unavailability,
    editId,
    editUnavailability,
    onCloseModalClick,
    onAddNewUnavailability,
    onSave,
    showModal,
    setShowModal,
    showDeleteModal,
    onCloseDeleteModal,
    handleDeleteClick,
    handleConfirmDelete,
    modalMode,
  } = useBarberUnavailability();

  if (barberList == null) {
    return <div>Loading...</div>;
  }

  return (
    <div className="content">
      <div className="content-block">
        <Breadcrumb parent="Staff" child="Unavailable Staff" />

        {showMessage && (
          <AlertMessage
            key={message.text}
            setVisible={setShowMessage}
            message={message.text}
            type={message.type}
            duration={4000}
          />
        )}
        <div className="card p-3">
          <div className="row">
            <div className="col-4 form-control-container">
              <label htmlFor="Barber" className="form-label form-control-label">
                Barber
              </label>
              <Combobox
                onChange={(value) => setSelectedBarber(value)}
                data={barberList}
                dataKey="id"
                textField="name"
                value={selectedBarber}
                defaultValue={selectedBarber}
                containerClassName="form-combobox"
              />
            </div>
            <div className="col-4 form-control-container ">
              <label
                htmlFor="FromDate"
                className="form-label form-control-label"
              >
                From Date
              </label>
              <input
                type="date"
                className="form-control form-input"
                value={selectedFromDate}
                onChange={(e) => setSelectedFromDate(e.target.value)}
              />
            </div>
            <div className="col-4 form-control-container ">
              <label htmlFor="ToDate" className="form-label form-control-label">
                To Date
              </label>
              <input
                type="date"
                className="form-control form-input"
                value={selectedToDate}
                onChange={(e) => setSelectedToDate(e.target.value)}
              />
            </div>
          </div>
        </div>
        <BarberUnavailabilityModal
          isOpen={showModal}
          onClose={onCloseModalClick}
          onSave={onSave}
          mode={modalMode}
          source="page"
          initialData={unavailability}
        />

        <Table
          columns={columns}
          data={unavailabilities}
          onDelete={handleDeleteClick}
          onEdit={editUnavailability}
          onAddClick={onAddNewUnavailability}
          title={"Unavailable List"}
        />
        <DeleteConfirmationModal
          show={showDeleteModal}
          onClose={onCloseDeleteModal}
          onConfirm={handleConfirmDelete}
          message="Are you sure you want to delete this unavailability?"
        />
      </div>
    </div>
  );
};

export default BarberUnavailability;
